export function getCourseTypeData(){
    var options=[
        {
            value: '1',
            label: '科普类',
            children: [{
              value: '1-1',
              label: '科普讲座',
            },
            {
                value: '1-2',
                label: '自然科学实验',
              },
              {
                value: '1-3',
                label: '信息技术',
              },
              {
                value: '1-4',
                label: '模型制作',
              },
              {
                value: '1-5',
                label: '创客',
              },
              {
                value: '1-6',
                label: 'STEM课程',
              },
              {
                value: '1-7',
                label: '天文地理观测研究',
              },
              {
                value: '1-8',
                label: '其它科普类',
              },
            ]
          },
          {
            value: '2',
            label: '文化艺术类',
            children: [{
              value: '2-1',
              label: '舞蹈',
            },
            {
                value: '2-2',
                label: '音乐',
              },
              {
                value: '2-3',
                label: '美术',
              },
              {
                value: '2-4',
                label: '戏剧与影视类',
              },
              {
                value: '2-5',
                label: '书法',
              },
              {
                value: '2-6',
                label: '摄影',
              },
              {
                value: '2-7',
                label: '中国传统艺术',
              },
              {
                value: '2-8',
                label: '其它文化艺术类',
              },
            ]
          },
          {
            value: '3',
            label: '体育类',
            children: [{
              value: '3-1',
              label: '基础体能（田径类）',
            },
            {
                value: '3-2',
                label: '足球',
              },
              {
                value: '3-3',
                label: '篮球',
              },
              {
                value: '3-4',
                label: '排球',
              },
              {
                value: '3-5',
                label: '羽毛球',
              },
              {
                value: '3-6',
                label: '乒乓球',
              },
              {
                value: '3-7',
                label: '体操运动',
              },
              {
                value: '3-8',
                label: '水上运动',
              },
              {
                value: '3-9',
                label: '冰雪运动',
              },
              {
                value: '3-10',
                label: '登山运动',
              },
              {
                value: '3-11',
                label: '棋牌',
              },
              {
                value: '3-12',
                label: '武术',
              },
              {
                value: '3-13',
                label: '趣味体育',
              },
              {
                value: '3-14',
                label: '其它体育类',
              },
              {
                value: '3-15',
                label: '健康知识',
              },
            ]
          },
          {
            value: '4',
            label: '劳动类',
            children: [{
              value: '4-1',
              label: '清洁与卫生',
            },
            {
                value: '4-2',
                label: '整理与收纳',
              },
              {
                value: '4-3',
                label: '烹饪与营养',
              },
              {
                value: '4-4',
                label: '家用器具使用与维护',
              },
              {
                value: '4-5',
                label: '传统工艺制作',
              },
              {
                value: '4-6',
                label: '农业生产劳动',
              },
              {
                value: '4-7',
                label: '工业生产劳动',
              },
              {
                value: '4-8',
                label: '其它劳动类',
              },
            ]
          },
          {
            value: '5',
            label: '阅读类',
            children: [{
              value: '5-1',
              label: '自主阅读',
            },
            {
                value: '5-2',
                label: '教师引导阅读',
              },
              {
                value: '5-3',
                label: '其它阅读类',
              },
            ]
          },
          {
            value: '6',
            label: '德育实践类',
            children: [{
              value: '6-1',
              label: '党史教育',
            },
            {
                value: '6-2',
                label: '爱国主义教育',
              },
              {
                value: '6-3',
                label: '心理健康',
              },
              {
                value: '6-4',
                label: '生命安全',
              },
              {
                value: '6-5',
                label: '生态文明',
              },
              {
                value: '6-6',
                label: '品德教育',
              },
              {
                value: '6-7',
                label: '团队活动',
              },
              {
                value: '6-8',
                label: '其它德育实践类',
              },
            ]
          },
          {
            value: '7',
            label: '校外活动类',
            children: [{
              value: '7-1',
              label: '爱国主义教育基地',
            },
            {
                value: '7-2',
                label: '综合活动实践基地',
              },
              {
                value: '7-3',
                label: '公共文化设施',
              },
              {
                value: '7-4',
                label: '青少年宫',
              },
              {
                value: '7-5',
                label: '科技场所',
              },
              {
                value: '7-6',
                label: '志愿服务活动',
              },
              {
                value: '7-7',
                label: '其他校外活动类',
              },
            ]
          },
    ];
    return options
}